<ng-container *ngIf="isLoaded; else loading">
    <mat-dialog-content>
        <div class="flex-row flex-space-between p-20 bg-accent">
            <div>
                <mat-card-header>
                    <mat-card-title>
                        {{ this.editPost ? 'Edit' : 'New' }} discussion
                    </mat-card-title>
                </mat-card-header>
            </div>
            <div class="float-end">
                <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                        tabindex="-1">
                    <mat-icon class="accent-text">close</mat-icon>
                </button>
            </div>
        </div>
        <div class="p-20 pb-10">
            <form [formGroup]="createPostForm">
                <mat-form-field appearance="outline" class="w-100" color="accent">
                    <mat-label>Discussion Title</mat-label>
                    <input formControlName="title" matInput>
                    <mat-error *ngIf="createPostForm.controls['title'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="communities.length > 1" appearance="outline" class="w-100" color="accent">
                    <mat-label>Community</mat-label>
                    <mat-select formControlName="community">
                        <mat-option *ngFor="let community of communities" [value]="community.id">{{ community.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="createPostForm.controls['community'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="communityId" appearance="outline" class="w-100 mb-10" color="accent">
                    <mat-label>Subgroups</mat-label>
                    <input [formControl]="subgroupSearchControl"
                           [matAutocomplete]="auto"
                           [matChipInputFor]="chipList"
                           matInput
                           placeholder="Select Subgroup">
                    <mat-autocomplete #auto="matAutocomplete"
                                      (optionSelected)="selectSubgroup($event.option.value)"
                                      [displayWith]="displayFn">
                        <ng-container
                                *ngFor="let subgroup of filteredSubgroups | async">
                            <mat-option
                                    *ngIf="!checkIfInArray(subgroup, this.currentSubgroups)"
                                    [value]="subgroup">
                                {{ subgroup.name }}
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                    <mat-chip-grid #chipList aria-label="Users Selection">
                        <mat-chip (removed)="removeSubgroup(subgroup)"
                                  *ngFor="let subgroup of this.currentSubgroups"
                                  class="smChip">
                            {{ subgroup.name }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-grid>
                    <mat-hint *ngIf="!subgroups.length">You have no subgroups in this community</mat-hint>
                </mat-form-field>

                <mat-form-field *ngIf="isSuperuser || hasCommunityRole(['full_admin', 'client'])"
                                [class.pb-10]="!categories.length" appearance="outline" class="w-100"
                                color="accent">
                    <mat-label>Categories</mat-label>
                    <mat-select [disabled]="!categories.length" formControlName="categories" multiple placeholder="All">
                        <mat-option *ngFor="let category of categories"
                                    [value]="category.id">{{ this.community?.member_generated_name && category.name == 'Member Generated' ? this.community?.member_generated_name : category?.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="!categories.length">You have no categories in your current community</mat-hint>
                </mat-form-field>
                <div class="d-flex flex-row w-100 gap-10 max-w-100 mobileReverseColumn">
                    <div class="flex-auto max-w-100">
                        <ckeditor (ready)="onReady($event)" [config]="config" [editor]="Editor" class="w-100"
                                  formControlName="text"></ckeditor>
                        <small *ngIf="this.createPostForm.value.text.length <= 0 " class="errorMsg"> This field is
                            required</small>
                    </div>
                    <div *ngIf="emojiEnabled" class="flex-col flex-space-between emoji">
                        <app-emoji-menu [ckEditorField]="editorInstance" [formControl]="textFormControl"
                                        matSuffix></app-emoji-menu>
                    </div>
                </div>
                <div class="d-flex flex-row gap-10 mt-10 flex-wrap">
                    <mat-checkbox *ngIf="hasCommunityRole(['member'])" formControlName="is_anonymous">Post Anonymously
                    </mat-checkbox>
                    <ng-container
                            *ngIf="isSuperuser|| hasCommunityRole(['full_admin', 'client']) ">
                        <mat-checkbox formControlName="is_closed_loop">Mark Post
                            as {{ community.close_the_loop_name ? community.close_the_loop_name : 'Close the Loop' }}
                        </mat-checkbox>
                    </ng-container>
                    <ng-container
                            *ngIf="isSuperuser|| hasCommunityRole(['full_admin']) ">
                        <mat-checkbox formControlName="is_pinned">Pin the post to the top of the feed</mat-checkbox>
                        <mat-checkbox formControlName="is_pinned_to_sidebar">Pin post in sidebar</mat-checkbox>
                        <mat-checkbox *ngIf="!community.hide_moderated" formControlName="hide_unmoderated_comments">
                            Hide un-moderated comments
                        </mat-checkbox>
                    </ng-container>
                </div>

                <mat-form-field *ngIf="isClosedLoop" [hidden]="!isClosedLoop" appearance="outline" class="w-100">
                    <mat-label>Close the loop parent</mat-label>
                    <input [formControl]="postSearchControl"
                           [matAutocomplete]="postAuto"
                           formControlName="original_post"
                           matInput
                           placeholder="Choose Post"
                           type="text">
                    <mat-icon *ngIf="postSearchLoading" matSuffix>
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                    <mat-autocomplete #postAuto="matAutocomplete" [displayWith]="postDisplayFn">
                        <mat-option *ngFor="let option of filteredPosts" [value]="option">{{ option.title }}
                        </mat-option>
                    </mat-autocomplete>

                </mat-form-field>
            </form>
            <form *ngIf="isSuperuser || hasCommunityRole(['full_admin', 'client'])" [formGroup]="createPostForm">
                <div class="mt-10 mb-10 d-flex align-items-center">
                    <mat-checkbox [formControl]="lockPostControl">lock a post with a pre-set time</mat-checkbox>
                </div>
                <div [class.d-none]="!lockPostControl.value" class="d-flex flex-row gap-10 mt-20">
                    <mat-form-field appearance="outline" color="accent">
                        <mat-label>Select lock date</mat-label>
                        <input [formControl]="dateControl" [matDatepicker]="picker" matInput>
                        <mat-datepicker-toggle (click)="clearDate()" *ngIf="dateControl.value" matIconSuffix>
                            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <app-time-picker [appearance]="'outline'" [formControl]="timeControl" label="Select lock time"/>
                </div>

                <div [class.d-none]="!lockPostControl.value" class="d-flex flex-row gap-10 mt-10">
                    <mat-checkbox formControlName="off_comments_at_time">Lock comments</mat-checkbox>
                    <mat-checkbox formControlName="off_likes_at_time">Lock likes</mat-checkbox>
                    <mat-checkbox formControlName="off_dislikes_at_time">Lock dislikes</mat-checkbox>
                </div>
            </form>
            <div class="mt-10 mb-10 d-flex flex-col gap-10">
                <h3>Attachments:</h3>
                <div class="flex-row gap-10 flex-wrap">

                    <app-attachments (inUse)="setUse($event, 'docInUse')" (isValid)="docValidEmitter($event)"
                                     (submitField)="setDocument($event)"
                                     [attachmentOptions]="['text','doc']"
                                     [class.attachmentInUse]="docInUse"
                                     [initialAttachment]="initialDocument">
                    </app-attachments>
                    <app-attachments (inUse)="setUse($event, 'urlInUse')" (isValid)="urlValidEmitter($event)"
                                     (submitField)="setUrl($event)"
                                     [attachmentOptions]="['text','url']"
                                     [class.attachmentInUse]="urlInUse"
                                     [initialAttachment]="initialUrl">
                    </app-attachments>
                    <app-attachments (inUse)="setUse($event, 'audioInUse')" (isValid)="audioValidEmitter($event)"
                                     (submitField)="setAudio($event)"
                                     [attachmentOptions]="['text','audio']"
                                     [class.attachmentInUse]="audioInUse"
                                     [initialAttachment]="initialAudio">
                    </app-attachments>
                    <app-attachments
                            (imagePositionChange)="this.createPostForm.patchValue({show_attachment_above_text: $event})"
                            (inUse)="setUse($event, 'imageInUse')"
                            (isValid)="imageValidEmitter($event)"
                            (submitField)="setImage($event)"
                            [attachmentOptions]="['text','image']"
                            [class.attachmentInUse]="imageInUse"
                            [displayOverText]="this.editPost?.show_attachment_above_text"
                            [initialAttachment]="initialImage">
                    </app-attachments>
                    <app-attachments (inUse)="setUse($event, 'multiAttachmentInUse')"
                                     (isValid)="attachmentsValidEmitter($event)"
                                     (removedAttachment)="removedPollOrHeatmap.emit($event)"
                                     (submitField)="getAttachmentField($event)"
                                     [attachmentOptions]="defaultAttachments"
                                     [class.attachmentInUse]="multiAttachmentInUse"
                                     [initialAttachment]="initialAttachment">
                    </app-attachments>
                    <app-attachments #attachmentComponentRef (inUse)="setUse($event, 'surveyPollInUse')"
                                     (isValid)="pollSurveyValidEmitter($event)"
                                     (removedAttachment)="removedPollOrHeatmap.emit($event)"
                                     (submitField)="setSurveyPoll($event)"
                                     (updatedPoll)="updatedPoll.emit()"
                                     *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'client']))"
                                     [attachmentOptions]="['text', 'survey_url', 'poll']"
                                     [class.attachmentInUse]="surveyPollInUse"
                                     [initialAttachment]="initialSurveyPoll">
                    </app-attachments>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="w-100 d-flex flex-space-around pb-15">
            <button color="warn" mat-dialog-close mat-raised-button>
                Cancel
            </button>
            <div [matTooltip]="this.validateForm(this.createPostForm)">
                <button (click)="!editPost ? createPost() : update()"

                        [disabled]="!attachmentsValid ||!docValid||!urlValid ||!pollSurveyValid || this.createPostForm.invalid || sending"
                        color="accent"
                        mat-raised-button>
                    {{ !editPost ? 'Start discussion' : 'Edit discussion' }}
                    <mat-icon *ngIf="sending">
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</ng-container>

<ng-template #loading>
    <div class="d-flex flex-center align-items-center loader-container">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>
